import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
    selectedWorker: [],
    selectedPTW: [],
    selectedSafetyTeam: []
}

export const hepActivtityContext = createSlice({
    name: "hepActivityContext",
    initialState: INITIAL_STATE,
    reducers: {
        setWorkerList: (state, action) => {
            state.selectedWorker = action.payload;
        },
        setPTWList: (state, action) => {
            state.selectedPTW = action.payload;
        },
        setSafetyTeamList: (state, action) => {
            state.selectedSafetyTeam = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { setWorkerList, setPTWList, setSafetyTeamList } = hepActivtityContext.actions;

export default hepActivtityContext.reducer;
